import React, { useEffect, useState } from "react"
import { AsyncTypeahead } from "react-bootstrap-typeahead"
import { useTranslation } from "react-i18next"

import CustomDatePicker from "../../components/Common/Form/DatePicker"
import CustomDropdown from "../../components/Common/Form/Dropdown"
import { useGetPartNumbers } from "../../services/queries"

const FilterListPriceUpload = (props) => {
    const {
        currencyOption,
        salesOrgOptions,
        priceTableIdOptions,
        priceLevelIdentifierOptions,
        onSelectFilterChange,
        onInputFilterChange,
        filterValueDefault
    } = props
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const [partNumberoptions, setPartNumberoptions] = useState([])
    const [filterParam, setFilterParam] = useState("")
    const { data: partNumbers } = useGetPartNumbers(filterParam)

    const [validity, setValidity] = useState({
        validityFrom: filterValueDefault?.validityFrom || "",
        validityTo: filterValueDefault?.validityTo || ""
    })

    useEffect(()=>{
        if(partNumbers?.length>0){
            setIsLoading(false)
            const partNumberOption = partNumbers.map(
                ({ part_number }) => {
                    return {
                        label: part_number,
                        value: part_number
                    }
                },
                [partNumbers?.data]
            )
            setPartNumberoptions(partNumberOption)
        }
        
    },[partNumbers])

    const onChangeInput = (value, name) => {
        setValidity((data) => {
            return {
                ...data,
                [name]: value
            }
        })
        onInputFilterChange(value, name)
    }

    const handlePartNumberSearch = (query) => {
        setIsLoading(true)
        setFilterParam(query)
    }

    const filterBy = () => true

    return (
        <div className="flex flex-col gap-4 pt-5">
            <div>
                <CustomDropdown
                    placeholder={ t("Pricing.currency") }
                    defaultValue={ filterValueDefault?.currencyList || "" }
                    options={ currencyOption || [] }
                    name="currencyList"
                    changeHandler={ onSelectFilterChange }
                    errorData={ "" }
                    isRequired={ false }
                    isMulti={ true }
                    disabled={ false }
                    dataTestId="currencyList"
                    isMultiWithCheckbox={ true }
                    AllSelectLabel = { "ALL" }
                    isAllOption = { true }
                    isValueSelect={ true }
                />
            </div>
            <div>
                <CustomDropdown
                    placeholder={ t("Pricing.salesOrgCode") }
                    defaultValue={ filterValueDefault?.salesOrgList || "" }
                    options={ salesOrgOptions || [] }
                    name="salesOrgList"
                    changeHandler={ onSelectFilterChange }
                    errorData={ "" }
                    isRequired={ false }
                    isMulti={ true }
                    disabled={ false }
                    dataTestId="salesOrgList"
                    isMultiWithCheckbox={ true }
                    AllSelectLabel = { "ALL" }
                    isAllOption = { true }
                    isValueSelect={ true }
                />
            </div>
            <div>
                <AsyncTypeahead
                    filterBy={ filterBy }
                    id="part-number"
                    name="partNumberList"
                    defaultInputValue={ filterValueDefault?.partNumberList?.length>0 && filterValueDefault?.partNumberList[0]?.value || "" }
                    isLoading={ isLoading }
                    labelKey="label"
                    minLength={ 3 }
                    onSearch={ handlePartNumberSearch }
                    options={ partNumberoptions }
                    placeholder={ t("Pricing.partNoCode") }
                    onChange={ (selectedOption) =>
                        onSelectFilterChange(selectedOption, "partNumberList")  }
                    renderMenuItemChildren={ (option) => (
                        <><span>{ option.label }</span></>
                    ) }
                    delay={ 500 }
                    useCache={ true }
                />
            </div>
            <div>
                <CustomDropdown
                    placeholder={ t("Pricing.priceTableId") }
                    defaultValue={ filterValueDefault?.priceTableIdList || "" }
                    options={ priceTableIdOptions || [] }
                    name="priceTableIdList"
                    changeHandler={ onSelectFilterChange }
                    errorData={ "" }
                    isRequired={ false }
                    isMulti={ true }
                    disabled={ false }
                    dataTestId="priceTableIdList"
                    isMultiWithCheckbox={ true }
                    AllSelectLabel = { "ALL" }
                    isAllOption = { true }
                    isValueSelect={ true }
                />
            </div>
            <div>
                <CustomDropdown
                    placeholder={ t("Pricing.priceLevelIdentifier") }
                    defaultValue={ filterValueDefault?.priceLevelIdentifierList || "" }
                    options={ priceLevelIdentifierOptions || [] }
                    name="priceLevelIdentifierList"
                    changeHandler={ onSelectFilterChange }
                    errorData={ "" }
                    isRequired={ false }
                    isMulti={ true }
                    disabled={ false }
                    dataTestId="priceLevelIdentifierList"
                    isMultiWithCheckbox={ true }
                    AllSelectLabel = { "ALL" }
                    isAllOption = { true }
                    isValueSelect={ true }
                />
            </div>
            <div>
                <CustomDatePicker
                    className=""
                    selected={ validity?.validityFrom }
                    placeHolder={ t("Pricing.validityFrom") }
                    value={ validity?.validityFrom }
                    id="validityFrom"
                    name="validityFrom"
                    onChangehandler={ onChangeInput }
                    isFutureDateDisabled={ false }
                    isPastDateDisabled={ true }
                    isComponentLabelValidation={ false }
                    errorData={ false }
                    isRequired={ false }
                />
            </div>
            <div>
                <CustomDatePicker
                    className=""
                    selected={ validity?.validityTo }
                    placeHolder={ t("Pricing.validityTo") }
                    value={ validity?.validityTo }
                    id="validityTo"
                    name="validityTo"
                    onChangehandler={ onChangeInput }
                    isFutureDateDisabled={ false }
                    isPastDateDisabled={ true }
                    isComponentLabelValidation={ false }
                    errorData={ false }
                    isRequired={ false }
                />
            </div>
        </div>
    )
}

export default FilterListPriceUpload
